var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkUsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 142,
    viewBox: "0 0 130 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4203 108.755C98.3103 108.755 120.92 86.2428 120.92 58.3652C120.92 30.4877 98.2105 7.96655 70.4203 7.96655C42.5312 7.96655 19.9214 30.4877 19.9214 58.3652C19.9214 86.2428 42.5312 108.755 70.4203 108.755Z",
    fill: "#DEFFF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.235 25.4263C119.49 25.4263 121.318 23.6072 121.318 21.3584C121.318 19.1181 119.49 17.2905 117.235 17.2905C114.98 17.2905 113.151 19.1181 113.151 21.3584C113.151 23.6072 114.98 25.4263 117.235 25.4263Z",
    fill: "#ECEFF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.211 9.55865C124.751 9.55865 126 8.31222 126 6.77938C126 5.24653 124.751 4 123.211 4C121.671 4 120.422 5.24653 120.422 6.77938C120.422 8.31222 121.671 9.55865 123.211 9.55865Z",
    fill: "#ECEFF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2117 25.3251C23.7525 25.3251 25.0007 24.0871 25.0007 22.5543C25.0007 21.013 23.7525 19.7749 22.2117 19.7749C20.6718 19.7749 19.4229 21.013 19.4229 22.5543C19.4229 24.0871 20.6718 25.3251 22.2117 25.3251Z",
    fill: "#ECEFF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17953 78.8993C8.04032 78.8993 10.3591 76.5916 10.3591 73.7364C10.3591 70.8897 8.04032 68.582 5.17953 68.582C2.31874 68.582 0 70.8897 0 73.7364C0 76.5916 2.31874 78.8993 5.17953 78.8993Z",
    fill: "#F1F3F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_30_17132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.954 92.7702C98.7266 102.751 85.5059 109 70.8215 109C59.1018 109 48.314 105.025 39.7451 98.3457V16.0942C39.7451 13.3739 41.9446 11.1504 44.6887 11.1504H93.7331L107.954 25.3671V92.7702Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6959 91.751H52.5537C52.2873 91.751 52.0742 91.0604 52.0742 90.235C52.0742 89.4097 52.2873 88.719 52.5537 88.719H59.6959C59.9623 88.719 60.1754 89.4097 60.1754 90.235C60.1754 91.1952 59.9623 91.751 59.6959 91.751Z",
    fill: "#ECEFF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4121 28.2052H53.0399C52.5198 28.2052 52.0742 27.5061 52.0742 26.6891C52.0742 25.8806 52.5198 25.1816 53.0399 25.1816H75.4121C75.9321 25.1816 76.3786 25.8806 76.3786 26.6891C76.3786 27.5061 75.9321 28.2052 75.4121 28.2052Z",
    fill: "#ECEFF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5594 35.2635H52.727C52.3752 35.2635 52.0742 34.5645 52.0742 33.7559C52.0742 32.939 52.3752 32.24 52.727 32.24H58.5087C58.8613 32.24 59.1623 32.939 59.1623 33.7559C59.1623 34.5645 58.8613 35.2635 58.5594 35.2635Z",
    fill: "#ECEFF2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8605 74.6035H66.1312H63.0751H53.8315C53.4594 74.6035 53.0864 75.2352 53.0864 76.1111C53.0864 76.8691 53.3841 77.6272 53.8315 77.6272H63.0751H66.1312H93.8605C94.2335 77.6272 94.6064 76.9955 94.6064 76.1111C94.5319 75.2352 94.2335 74.6035 93.8605 74.6035Z",
    fill: "#ECEFF2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8597 66.5352H83.5539H80.0445H53.8331C53.4593 66.5352 53.0864 67.1669 53.0864 68.0428C53.0864 68.8008 53.3849 69.5587 53.8331 69.5587H80.0445H83.5539H93.8597C94.2326 69.5587 94.6064 68.9271 94.6064 68.0428C94.5319 67.1669 94.2326 66.5352 93.8597 66.5352Z",
    fill: "#ECEFF2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9235 59.4685H92.1803H89.4362H53.8483C53.467 59.4685 53.0864 60.1002 53.0864 60.9845C53.0864 61.7425 53.3909 62.5005 53.8483 62.5005H89.4362H92.4847H94.8474C95.2279 62.5005 95.6093 61.8689 95.6093 60.9845C95.6854 60.2265 95.304 59.4685 94.9235 59.4685Z",
    fill: "#ECEFF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8634 51.4004H86.0249H83.8338H53.8416C53.4644 51.4004 53.0864 52.032 53.0864 52.9163C53.0864 53.6743 53.3883 54.4324 53.8416 54.4324H83.8338H86.0249H94.7882C95.3167 54.4324 95.6186 53.8007 95.6186 52.9163C95.6186 52.1583 95.3167 51.4004 94.8634 51.4004Z",
    fill: "#ECEFF2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.333 11.5042V22.352C93.333 24.2133 94.8467 25.7209 96.7156 25.7209H108.4",
    fill: "#29D99A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1092 39.7354V70.9818C59.1092 74.6371 56.1038 77.2985 52.7644 77.2985H51.0942V85.6112C51.0942 87.6073 48.7569 88.2726 47.4208 86.9419L39.0718 77.2985H6.34481C2.67136 77.2985 0 74.3086 0 70.9818V39.7354C0 36.0801 3.00539 33.4187 6.34481 33.4187H52.7644C56.1038 33.4187 59.1092 36.4086 59.1092 39.7354Z",
    fill: "#29D99A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29 46.25C27.0716 46.25 25.1866 46.8218 23.5832 47.8932C21.9798 48.9645 20.7301 50.4873 19.9922 52.2688C19.2542 54.0504 19.0611 56.0108 19.4373 57.9021C19.8136 59.7934 20.7422 61.5307 22.1057 62.8943C23.4693 64.2579 25.2066 65.1865 27.0979 65.5627C28.9892 65.9389 30.9496 65.7458 32.7312 65.0078C34.5127 64.2699 36.0355 63.0202 37.1068 61.4168C38.1782 59.8134 38.75 57.9284 38.75 56C38.745 53.4157 37.7162 50.9386 35.8888 49.1112C34.0614 47.2838 31.5843 46.255 29 46.25ZM33.6406 54.2938L28.1469 59.5438C28.0049 59.6774 27.8169 59.7512 27.6219 59.75C27.5266 59.7514 27.4319 59.7338 27.3434 59.6984C27.2549 59.663 27.1743 59.6105 27.1063 59.5438L24.3594 56.9188C24.2832 56.8523 24.2212 56.7711 24.1772 56.6801C24.1332 56.589 24.1081 56.49 24.1033 56.389C24.0985 56.2881 24.1142 56.1871 24.1494 56.0924C24.1846 55.9976 24.2387 55.9109 24.3082 55.8375C24.3778 55.7642 24.4615 55.7056 24.5543 55.6654C24.647 55.6252 24.747 55.6042 24.8481 55.6036C24.9492 55.603 25.0494 55.6229 25.1426 55.662C25.2358 55.7011 25.3202 55.7587 25.3906 55.8312L27.6219 57.9594L32.6094 53.2062C32.7552 53.079 32.9446 53.0131 33.1379 53.0222C33.3312 53.0314 33.5135 53.1149 33.6467 53.2553C33.7798 53.3958 33.8536 53.5822 33.8524 53.7758C33.8513 53.9693 33.7754 54.1549 33.6406 54.2938Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_30_17132",
    x: 17.7451,
    y: 0.150391,
    width: 112.209,
    height: 141.849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.239216 0 0 0 0 0.25098 0 0 0 0 0.266667 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30_17132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_17132",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkUsed);
export default __webpack_public_path__ + "static/media/link_used.3a078f92a0ad4c06141383224544178e.svg";
export { ForwardRef as ReactComponent };